import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const CityListText = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${theme.greyText};
`;
